module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-mobile-produs.4dc6e507.png";